/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import saga from '../sagas';
import * as expressCartsActions from '../actions';
import injectSaga from '../../../utils/injectSaga';
import injectReducer from '../../../utils/injectReducer';
import Reducer from '../reducer';
import ExpressCart from '../../../components/ExpressCart/index';
import * as loaderActions from '../../../components/common/Loader/action';
import * as taggingActions from '../../Common/Tagging.js/actions';
import taggingSaga from '../../Common/Tagging.js/sagas';
import * as cartActions from '../../../services/Cart/actions';
import cartDetails from '../../../services/Cart/reducer';
import cartSaga from '../../../services/Cart/sagas';

const mapStateToProps = (state) => {
  const expressState = state;
  const loader = state.loader || {};
  const {showCartApiError, notifyErrorMsg} = state.cartDetails;
  return {
    expressState,
    loader,
    showCartApiError,
    notifyErrorMsg,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...expressCartsActions, ...loaderActions, ...taggingActions, ...cartActions }, dispatch);

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);

const withSaga = compose(injectSaga({ key: 'expressCart', saga }),
  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
  injectSaga({ key: 'cartDetails', saga: cartSaga }));

const withReducer = compose(
  injectReducer({ key: 'expressCart', reducer: Reducer }),
  injectReducer({ key: 'cartReducer', reducer: cartDetails }),
);

export default withRouter(
  compose(
    withReducer,
    withSaga,
    withConnect
  )(ExpressCart)
);
